export default __webpack_public_path__ + "static/media/coleta.048a488d.svg";